import {Injectable} from "@angular/core";
import {Response, URLSearchParams} from "@angular/http";
import {Observable} from "rxjs/Observable";
import "rxjs/add/observable/throw";

/**
 * This class provides the Patient service with methods to read patients
 */
@Injectable()
export class UtilService {
  constructor() {
  }

  setQueryParams(params: object): URLSearchParams {
    let query = new URLSearchParams();
    for (let p in params) {
      if (params.hasOwnProperty(p) && (params[p] || typeof params[p] === "string")) {
        query.set(p, params[p]);
      }
    }
    return query;
  }

  leftPadDay(dayStr: any) {
    if (!isNaN(Number(dayStr)) && Number(dayStr) < 9 && Number(dayStr) > 0) {
      return "0" + Number(dayStr);
    }
    return dayStr;
  }

  handleError(error: any) {
    let errMsg = error.message
      ? error.message
      : error.status ? `${error.status} - ${error.statusText}` : "Server error";
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

  outputParser(res: Response) {
    let responseText: string = res.text();
    if (!responseText) {
      return null;
    }
    try {
      return JSON.parse(responseText);
    } catch (e) {
      return null;
    }
  }

  formatDate(year: string, month: string, day: number) {
    try {
      if (year.trim().length === 0 || month.trim().length === 0 || String(day).trim().length === 0) {
        return null;
      }

      return `${year}-${month}-${this.leftPadDay(day)}`;
    } catch (e) {
      return null;
    }
  }

  getEnvironmentString(env) {
    const {versions} = env;
    if (env.production) {
      return versions.version;
    }
    return `${versions.version}-${env.envName} r:${versions.revision} b:${versions.branch}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/util/util.service.ts